/* eslint-disable react/require-default-props */
import {
  Box,
  Button,
  ButtonProps,
  Fade,
  LinearProgress,
} from '@material-ui/core';
import React, { forwardRef, useEffect, useState } from 'react';

export type ButtonSubmitProps = ButtonProps & {
  loading?: boolean;
  allowSubmitWhenLoading?: boolean;
};

const ButtonSubmit = forwardRef<HTMLButtonElement, ButtonSubmitProps>(
  (
    { loading, children, onClick, allowSubmitWhenLoading, ...props },
    forwardedRef
  ) => {
    const [key, setKey] = useState(0);
    const [progress, setProgress] = React.useState(0);

    useEffect(() => {
      if (!loading) return;

      const timer = setInterval(setProgress, 50, oldProgress =>
        Math.min(20 + oldProgress, 75)
      );

      // eslint-disable-next-line consistent-return
      return () => clearInterval(timer);
    }, [loading, setProgress, setKey]);

    const handleClick: React.MouseEventHandler<HTMLButtonElement> = ev => {
      if (loading && !allowSubmitWhenLoading) {
        ev.preventDefault();
      } else {
        setProgress(0);
        setKey(v => v + 1);
        onClick?.(ev);
      }
    };

    return (
      <Button
        ref={forwardedRef}
        type="submit"
        onClick={handleClick}
        variant="contained"
        color="primary"
        {...props}
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        {children}
        <Fade
          key={key}
          in={loading}
          unmountOnExit
          mountOnEnter
          timeout={{ appear: 50, enter: 50, exit: 250 }}
          onExit={() => setProgress(100)}
        >
          <Box position="absolute" left={0} right={0} bottom={0}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
        </Fade>
      </Button>
    );
  }
);

ButtonSubmit.displayName = 'ButtonSubmit';

export default ButtonSubmit;
